import React from "react";
import { Link, useSearchParams } from "react-router-dom";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
  CardFooter,
} from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { CheckCircle } from "lucide-react";

const benefits = [
  "I'll remember the account information you've already entered.",
  "You can add up to 5 accounts and use the tool for free.",
  "I'll safely and securely save your API keys so you don't have to enter them every time.",
  "As you use more advanced features, I'll remember your preferences.",
];

const SignUpGatePage = () => {
  const [searchParams] = useSearchParams();
  const redirectUrl = searchParams.get("redirectUrl") || "/";

  return (
    <div className="container mx-auto flex items-center justify-center min-h-screen p-4">
      <Card className="w-full max-w-2xl">
        <CardHeader className="text-center">
          <CardTitle className="text-3xl">
            Create an Account to Unlock More
          </CardTitle>
          <CardDescription>
            It's free and unlocks the full power of the 80/20 Agent.
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-6">
          <ul className="space-y-3 text-muted-foreground">
            {benefits.map((benefit, index) => (
              <li key={index} className="flex items-start">
                <CheckCircle className="h-5 w-5 text-green-500 mr-3 mt-1 flex-shrink-0" />
                <span>{benefit}</span>
              </li>
            ))}
          </ul>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <Button asChild size="lg">
              <Link
                to={`/auth/sign-up?redirect_url=${encodeURIComponent(redirectUrl)}`}
              >
                Sign Up for Free
              </Link>
            </Button>
            <Button asChild variant="outline" size="lg">
              <Link
                to={`/auth/sign-in?redirect_url=${encodeURIComponent(redirectUrl)}`}
              >
                Sign In
              </Link>
            </Button>
          </div>
        </CardContent>
        <CardFooter className="flex justify-center">
          <Button asChild variant="ghost" className="text-muted-foreground">
            <Link to="/?sampleData=true">
              I'm not sure yet, let me explore with sample data
            </Link>
          </Button>
        </CardFooter>
      </Card>
    </div>
  );
};

export default SignUpGatePage;
